/* eslint-disable no-unused-vars */
import GenerateOverdueInvoiceChargesClientDTO from './generateOverdueInvoiceChargesClientDTO'

export default class GenerateOverdueInvoiceChargesDTO {
  constructor({
    invoiceCenterID,
    dueDateUTC,
    minimumDaysOverdue,
    selectedClients,
  } = {}) {
    /**
     * @type {Number}
     */
    this.invoiceCenterID = invoiceCenterID
    /**
     * @type {Date}
     */
    this.dueDateUTC = dueDateUTC
    /**
     * @type {Number}
     */
    this.minimumDaysOverdue = minimumDaysOverdue
    /**
     * @type {GenerateOverdueInvoiceChargesClientDTO[]}
     */
    this.selectedClients = selectedClients
  }
}
